// src/menu-items/statistics.ts
import { Plus, Group, UserPlus } from 'iconoir-react';


const proaccounts = {
  id: 'pro-accounts-group',
  title: 'Pro Accounts',
  type: 'group',
  children: [
    {
      id: 'group-search',
      title: 'Pro Accounts',
      type: 'item',
      url: '/group/search',
      icon: Group,
      breadcrumbs: true
    },
    {
      id: 'group-create',
      title: 'Create Pro Account',
      type: 'item',
      url: '/group/add',
      icon: Plus,
      breadcrumbs: true
    },
    {
      id: 'group-add',
      title: 'Add to Pro Account',
      type: 'item',
      url: '/group/addtopro',
      icon: UserPlus,
      breadcrumbs: true
    }
  ]
};

export default proaccounts;
